export default "__VITE_ASSET__CqIYFMJi__"